<template>
  <div>
    <SwiperComponent id="introduction" />
    <div class="home_container">
      <!-- <div class="top_bg">
      <img src="@/assets/img/home_top_img.png" alt="home_bg" />
    </div> -->
      <!-- <div class="top" id="introduction">
      <div class="title">OpenHarmony智能穿戴聚合平台</div>
      <div class="subtitle">
        一个专注于智能穿戴领域的<br />
        生态聚合平台
      </div>
      <div class="description">
        平台聚合了智能穿戴的开发者、终端设备厂商（含品牌厂商）以及最终的消费者<br />
        为应用和内容的分发提供了更加便捷的通路。
      </div>
    </div> -->
      <!-- 应用开发 -->
      <div class="app" id="application">
        <div class="app_box">
          <div class="overlay_top"></div>
          <div
            class="app_list"
            ref="appListContainer"
            @mouseenter="pauseAutoScroll"
            @mouseleave="startSmoothScroll"
            @wheel="onWheelScroll"
          >
            <div
              class="app_item"
              v-for="(item, index) in appIconList"
              :key="item.id"
              :class="'margin-top-' + (index % 4)"
            >
              <img class="app_item_icon" :src="item.icon" alt="app_icon" />
              <div class="app_item_name">{{ item.name }}</div>
            </div>
          </div>
          <div class="overlay_bottom"></div>
        </div>
        <div class="app_text_box">
          <div class="app_text">
            <div class="title_text">应用开发</div>
            <div class="description_text">
              开源鸿蒙操作系统为以智能手表为代表的轻智能、小屏类终端构建了完整的配套设施。开发者可以快速构建应用，大幅降低终端适配成本；借力成熟应用生态(覆盖健康/导航/娱乐场景)加速用户增长；依托海量设备入口，实现应用变现与硬件增值的双赢通路。
            </div>
            <!-- <el-button type="primary" class="app_button">立即咨询</el-button> -->
          </div>
        </div>
      </div>
      <!-- 表盘设计 -->
      <div class="app" id="dial">
        <div class="app_text_box">
          <div class="app_text">
            <div class="title_text">表盘设计</div>
            <div class="description_text">
              Dial Studio 表盘设计工具，支持开发者“所见即所得”的创作，支持视频动效、帧动画、万花筒、交互式控件等多元创作能力，助力设计师分钟级产出个性化表盘，无缝对接生态实现商业变现。
            </div>
            <!-- <el-button type="primary" class="app_button">立即咨询</el-button> -->
          </div>
        </div>
        <div class="app_box">
          <div class="overlay_top"></div>
          <div
            class="app_list"
            ref="dialListContainer"
            @mouseenter="pauseDialScroll"
            @mouseleave="startDialSmoothScroll"
            @wheel="onDialWheelScroll"
          >
            <div
              v-for="(item, index) in dialIconList"
              :key="item.id"
              :class="'margin-top-' + (index % 3)"
            >
              <img
                class="app_item_icon"
                :src="item"
                alt="dial_icon"
                style="width: 116px; height: 116px"
              />
            </div>
          </div>
          <div class="overlay_bottom"></div>
        </div>
      </div>
      <!-- 设备接入市场 -->
      <!-- <div class="market" id="market">
      <div class="market_left">
        <div class="title_text">设备接入市场</div>
        <div class="description_text">
          OpenHarmony智能穿戴聚合平台，现支持通过手机APP的方式集成H5应用市场、H5表盘市场，实现手表通过手机APP接入应用市场、表盘市场。
        </div>
      </div>
      <div class="market_right">
        <img src="@/assets/img/home_market.png" alt="home_market" />
      </div>
    </div> -->
      <!-- 平台介绍 -->
      <div class="banner" id="platform">
        <div class="banner_title">连接智能穿戴生态，聚合无限可能</div>
        <div class="banner_description">
          平台拉通了OpenHarmony智能穿戴的产业链上下游，
          聚合了智能穿戴的开发者、终端设备厂商（含品牌厂商）<br />
          以及最终的消费者，为应用和内容的分发提供了更加便捷的通路。
        </div>
        <div class="banner_content">
          <div class="banner_card">
            <div class="banner_card_icon">
              <img
                src="@/assets/img/home_banner_icon1.png"
                alt="banner_card_icon"
              />
            </div>
            <div class="banner_card_title">开发者</div>
            <div class="banner_card_description">
              开发者精心打造的应用上架到该平台后，可以快速的分发到消费者，从而快速实现商业变现。
            </div>
          </div>
          <div class="banner_card">
            <div class="banner_card_icon">
              <img
                src="@/assets/img/home_banner_icon2.png"
                alt="banner_card_icon"
              />
            </div>
            <div class="banner_card_title">终端设备厂商</div>
            <div class="banner_card_description">
              终端设备厂家借助该平台的应用和内容，可以有效提升产品的竞争力，增加用户粘性。
            </div>
          </div>
          <div class="banner_card">
            <div class="banner_card_icon">
              <img
                src="@/assets/img/home_banner_icon3.png"
                alt="banner_card_icon"
              />
            </div>
            <div class="banner_card_title">消费者</div>
            <div class="banner_card_description">
              消费者可以方便的下载并体验到各种智能穿戴创新应用，提升品牌忠诚度。
            </div>
          </div>
        </div>
      </div>
      <!-- 平台核心优势 -->
      <div class="home_advantage" id="platform">
        <div class="home_advantage_title">平台核心优势</div>
        <div class="home_advantage_content">
          <div class="left">
            <div class="advantage_card">
              <div class="advantage_card_title">统一规范的API和分发机制</div>
              <div class="advantage_card_description">
                基于 OpenHarmony Watch SIG 的统一 API
                规范，让开发者、终端设备厂商和用户都可以享受到更加规范、稳定的应用服务，避免兼容性问题带来的困扰，推动智能穿戴生态健康有序发展。
              </div>
              <div class="advantage_card_image">
                <img
                  src="@/assets/img/home_advantage_img1.png"
                  alt="advantage_card_image"
                />
              </div>
            </div>
            <div class="advantage_card" style="padding-bottom: 0px">
              <div class="advantage_card_title">强大的数据安全与隐私保护</div>
              <div class="advantage_card_description" style="margin-bottom: 0px">
                在提供丰富应用服务的同时，我们始终将用户数据安全与隐私权益放在首位，通过采用先进的数据加密技术并实施严格的隐私保护措施，确保每位用户的个人信息和应用数据都得到安全存储和严格保护。
              </div>
              <div class="advantage_card_image">
                <img
                  src="@/assets/img/home_advantage_img2.png"
                  alt="advantage_card_image"
                />
              </div>
            </div>
          </div>
          <div class="right">
            <div class="advantage_card">
              <div class="advantage_card_title">跨设备无缝连接</div>
              <div class="advantage_card_description">
                支持多种智能穿戴硬件平台，使得同一款应用可以在不同品牌和型号的智能手表之间无缝运行，让用户在不同设备之间享受一致且优质的服务体验。
              </div>
              <div class="advantage_card_image">
                <img
                  src="@/assets/img/home_advantage_img3.png"
                  alt="advantage_card_image"
                />
              </div>
            </div>
            <div class="advantage_card">
              <div class="advantage_card_title">持续更新的生态系统</div>
              <div class="advantage_card_description">
                OpenHarmony作为一个面向全球的开源生态，已经吸引了越来越多的开发者、设备厂商和用户的关注和参与，平台随着OpenHarmony生态的日益壮大，将逐步涵盖智能穿戴的日常应用场景，为全球的生态参与者提供持续服务，创造全新的生态价值。
              </div>
              <div class="advantage_card_image">
                <img
                  src="@/assets/img/home_advantage_img4.png"
                  alt="advantage_card_image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 开发者活动 -->
      <HomeActivity id="activity" />
      <!-- 合作伙伴 -->
      <HomePartner id="partner" />
      <!-- 侧边栏 -->
      <div class="side_bar">
        <div
          class="side_bar_item"
          v-for="item in sideBarList"
          :key="item.id"
          @click="scrollTo(item.id)"
        >
          <span :class="side_bar_id === item.id ? 'active' : ''">{{
            item.name
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppIconListPage, getDialIconListPage } from "@/api/home";
import HomeActivity from "./components/HomeActivity.vue";
import HomePartner from "./components/HomePartner.vue";
import SwiperComponent from "@/components/SwiperComponent.vue";

export default {
  name: "HomeView",
  components: {
    HomeActivity,
    HomePartner,
    SwiperComponent,
  },
  data() {
    return {
      appIconList: [],
      dialIconList: [],
      side_bar_id: "introduction",
      sideBarList: [
        {
          id: "introduction",
          name: "简介",
        },
        {
          id: "application",
          name: "应用",
        },
        {
          id: "dial",
          name: "表盘",
        },
        // {
        //   id: "market",
        //   name: "市场",
        // },
        {
          id: "platform",
          name: "平台介绍",
        },
        {
          id: "activity",
          name: "开发者活动",
        },
        {
          id: "partner",
          name: "合作伙伴",
        },
      ],
      scrollId: null,
      dialScrollId: null,
      isScrolling: false,
      isDialScrolling: false,
      appLoading: false,
      appPage: 0,
      appPageSize: 20,
      appTotal: 0,
      dialLoading: false,
      dialPage: 0,
      dialPageSize: 15,
      dialTotal: 0,
    };
  },
  created() {
    this.getAppIconList("first");
    this.getDialIconList("first");
    // 添加滚动监听器
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.startSmoothScroll();
    this.startDialSmoothScroll();
  },
  beforeDestroy() {
    // 移除滚动监听器
    window.removeEventListener("scroll", this.handleScroll);
    cancelAnimationFrame(this.scrollId);
    cancelAnimationFrame(this.dialScrollId);
  },
  methods: {
    async getAppIconList(type) {
      this.appLoading = true;
      if (type === "first") {
        this.appIconList = [];
        this.appPage = 1;
        this.appTotal = 0;
        this.appPageSize = 20;
      } else {
        if (Math.ceil(this.appTotal / 4) > this.appPage) {
          this.appPage++;
        } else {
          this.appPage = 1;
        }
      }
      let data = {
        page: this.appPage,
        pageSize: this.appPageSize,
      };
      try {
        const res = await getAppIconListPage(data);
        this.appIconList = this.appIconList.concat(res.data.records || []);
        this.appTotal = res.data.total;
        // this.appIconList = res.data.records || [];
        console.log("appIconList11111", this.appIconList);
        if (type === "first") {
          this.appPage = 5;
          this.appPageSize = 4;
        }
        this.appLoading = false;
      } catch (e) {
        console.error("iconListPage接口请求失败:", e);
      }
    },
    async getDialIconList(type) {
      this.dialLoading = true;
      if (type === "first") {
        this.dialIconList = [];
        this.dialPage = 1;
        this.dialTotal = 0;
        this.dialPageSize = 15;
      } else {
        if (Math.ceil(this.dialTotal / 3) > this.dialPage) {
          this.dialPage++;
        } else {
          this.dialPage = 1;
        }
      }
      let data = {
        page: this.dialPage,
        pageSize: this.dialPageSize,
      };
      try {
        const res = await getDialIconListPage(data);
        this.dialIconList = this.dialIconList.concat(res.data.records || []);
        this.dialTotal = res.data.total;
        console.log("dialIconList11111", this.dialIconList);
        if (type === "first") {
          this.dialPage = 5;
          this.dialPageSize = 3;
        }
        this.dialLoading = false;
      } catch (e) {
        console.error("iconListPage接口请求失败:", e);
      }
    },
    startSmoothScroll() {
      const container = this.$refs.appListContainer;
      const scroll = () => {
        if (this.isScrolling) return; // 如果是鼠标滚动中，则停止自动滚动

        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - 50
        ) {
          // console.log("到达底部");
          // container.scrollTop = 0; // 到达底部后，回到顶部
          if (this.appIconList.length >= 20 && !this.appLoading) {
            this.getAppIconList();
          }
        }
        container.scrollTop += 1; // 每次滚动1px

        this.scrollId = requestAnimationFrame(scroll); // 下一帧继续滚动
      };
      this.scrollId = requestAnimationFrame(scroll);
    },
    pauseAutoScroll() {
      cancelAnimationFrame(this.scrollId); // 暂停自动滚动
    },
    onWheelScroll(event) {
      const container = this.$refs.appListContainer;
      this.isScrolling = true;

      // 根据滚轮方向判断滚动
      if (event.deltaY > 0) {
        container.scrollTop += 10; // 向下滚动
      } else {
        container.scrollTop -= 10; // 向上滚动
      }

      // 延迟恢复自动滚动
      setTimeout(() => {
        this.isScrolling = false;
      }, 100); // 100ms 后恢复自动滚动
    },
    startDialSmoothScroll() {
      const container = this.$refs.dialListContainer;
      if (!container) return;

      const scroll = () => {
        if (this.isDialScrolling) return; // 如果是鼠标滚动中，则停止自动滚动
        // console.log(
        //   "container.scrollTop",
        //   container.scrollTop,
        //   container.clientHeight,
        //   container.scrollHeight
        // );
        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight - 50
        ) {
          // console.log("到达表盘底部");
          // container.scrollTop = 0; // 到达底部后，回到顶部
          if (this.dialIconList.length >= 15 && !this.dialLoading) {
            this.getDialIconList();
          }
        }
        container.scrollTop += 1; // 每次滚动2px

        this.dialScrollId = requestAnimationFrame(scroll); // 下一帧继续滚动
      };
      this.dialScrollId = requestAnimationFrame(scroll);
    },
    pauseDialScroll() {
      cancelAnimationFrame(this.dialScrollId); // 暂停自动滚动
    },
    onDialWheelScroll(event) {
      const container = this.$refs.dialListContainer;
      this.isDialScrolling = true;

      // 根据滚轮方向判断滚动
      if (event.deltaY > 0) {
        container.scrollTop += 10; // 向下滚动
      } else {
        container.scrollTop -= 10; // 向上滚动
      }

      // 延迟恢复自动滚动
      setTimeout(() => {
        this.isDialScrolling = false;
      }, 100); // 100ms 后恢复自动滚动
    },
    scrollTo(item) {
      // this.side_bar_id = item;
      console.log("item", item);
      const element = document.getElementById(item);
      if (element) {
        const offsetPosition = element.offsetTop - 80;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleScroll() {
      // 获取所有导航对应的区域
      const sections = this.sideBarList
        .map((item) => ({
          id: item.id,
          element: document.getElementById(item.id),
        }))
        .filter((item) => item.element);

      // 找到当前在视口中的区域
      const currentSection = sections.find((section) => {
        const rect = section.element.getBoundingClientRect();
        // 当元素的顶部进入视口的1/3位置时就认为是当前区域
        return (
          rect.top <= window.innerHeight / 5 &&
          rect.bottom >= window.innerHeight / 5
        );
      });
      console.log("currentSection", currentSection);

      // 更新高亮状态
      if (currentSection) {
        this.side_bar_id = currentSection.id;
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.home_container {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
}

.top_bg {
  width: 1280px;
  height: 567px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.top_bg img {
  width: 100%;
  height: 100%;
}

.top {
  width: 1280px;
  height: 567px;
  margin: 0 auto;
  background-image: url("@/assets/img/home_top_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.title {
  font-weight: 500;
  font-size: 14px;
  color: #3b82f6;
  text-align: center;
  padding-top: 180px;
}

.subtitle {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 36px;
  line-height: 40px;
  color: #1f2937;
  text-align: center;
  padding-top: 16px;
}

.description {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 16px;
  color: #6b7280;
  text-align: center;
  padding-top: 16px;
}

.app {
  width: 80%;
  padding-top: 45px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
}

.app_box {
  position: relative;
  width: 528px;
  height: 790px;
  padding-right: 20px;
  overflow-x: hidden;
}

/* 隐藏滚动条但保留滚动效果 */
.app_box::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}

.overlay_top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  ); /* 渐变色蒙层 */
  z-index: 1; /* 确保蒙层位于内容上层 */
}

.overlay_bottom {
  position: sticky;
  bottom: 0;
  left: 0;
  width: 528px;
  height: 120px;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  ); /* 渐变色蒙层 */
  z-index: 1; /* 确保蒙层位于内容上层 */
}

.app_list {
  width: 528px;
  display: grid;
  grid-template-columns: repeat(4, 2fr);
  /* display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap; */
  height: 790px;
  overflow-y: auto;
}

/* 隐藏滚动条但保留滚动效果 */
.app_list::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}

.app_item {
  width: 100px;
  height: 126px;
  margin: 0 auto;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  margin: 0 16px 32px 16px;
  padding-top: 18px;
  box-sizing: border-box;
  /* transform: scale(0.8, 0.8);
  transition: transform 0.2s ease-in-out; */
}

/* .app_item:hover {
  transform: scale(1);
} */

.app_item_icon {
  width: 60px;
  height: 60px;
  border-radius: 9px;
}

.app_item_name {
  font-weight: 500;
  font-size: 14px;
  color: #344054;
  line-height: 16px;
  text-align: center;
  margin-top: 8px;
}

/* 表盘列表样式 */
#dial > .app_box > .app_list {
  display: grid;
  grid-template-columns: repeat(3, 2fr);
}

#dial > .app_box > .app_list > div {
  width: 140px;
  height: 140px;
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.margin-top-0 {
  margin-top: 0px;
}
.margin-top-1 {
  transform: translateY(50px);
}
.margin-top-2 {
  transform: translateY(8px);
}
.margin-top-3 {
  transform: translateY(87px);
}
.app_text_box {
  width: 360px;
  /* height: 660px; */
  overflow-x: hidden;
  display: flex;
}
.app_text {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: 200px;
  /* transform: translateX(100%); */
  transition: transform 0.5s ease-in-out;
}
.app:hover .app_text {
  transform: translateX(0);
}
.title_text {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 30px;
  color: #1f2937;
  text-align: left;
  font-style: normal;
}
.description_text {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 16px;
  color: #6b7280;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  margin-top: 18px;
}
.app_button {
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  margin-top: 18px;
}
.app_text > .el-button--primary {
  font-weight: bold;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  margin-top: 18px;
  background-color: #3b82f6;
  border-color: #3b82f6;
  border-radius: 8px;
}

.market {
  width: 1280px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 90px;
}

.market_left {
  width: 360px;
}

.market_right > img {
  width: 636px;
  height: 767px;
}

.banner {
  width: 1280px;
  height: 686px;
  background-image: url("@/assets/img/home_banner_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.banner_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 36px;
  color: #1f2937;
  text-align: center;
  padding-top: 110px;
}

.banner_description {
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  line-height: 24px;
  text-align: center;
  padding-top: 26px;
}

.banner_content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 40px;
}

.banner_card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 296px;
  height: 290px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #e5e7eb;
  padding: 58px 44px 0 44px;
  margin: 0 16px;
}

.banner_card_icon > img {
  width: 32px;
  height: 32px;
}

.banner_card_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 18px;
  color: #1f2937;
  text-align: left;
  margin-top: 12px;
}

.banner_card_description {
  font-weight: 500;
  font-size: 16px;
  color: #6b7280;
  line-height: 24px;
  text-align: left;
  margin-top: 12px;
}

.home_advantage {
  width: 1024px;
  margin: 0 auto;
  margin-top: 112px;
}

.home_advantage_title {
  font-family: "HarmonyOS Sans SC-Bold";
  font-weight: bold;
  font-size: 36px;
  color: #1f2937;
  text-align: center;
  margin-bottom: 48px;
}

.home_advantage_content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.left {
  width: calc(50% - 16px);
}

.right {
  width: calc(50% - 16px);
}

.advantage_card {
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #e5e7eb;
  padding: 40px 0 40px 0;
  margin-bottom: 32px;
}

.advantage_card_title {
  font-weight: 500;
  font-size: 20px;
  color: #1f2937;
  text-align: left;
  padding: 0 40px;
}

.advantage_card_description {
  font-family: "HarmonyOS Sans SC-Regular";
  font-weight: 400;
  font-size: 14px;
  color: #6b7280;
  line-height: 20px;
  text-align: left;
  padding: 0 40px;
  margin-top: 12px;
  margin-bottom: 44px;
}

.advantage_card_image > img {
  width: 100%;
}

.side_bar {
  position: fixed;
  top: 20%;
  right: 44px;
  width: 98px;
  height: 270px;
  background: #ffffff;
  box-shadow: 0px 8px 5px 0px rgba(0, 0, 0, 0.08),
    0px 20px 13px 0px rgba(0, 0, 0, 0.03), 0px -2px 13px 0px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
  z-index: 100;
}

.side_bar_item {
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}

.active {
  color: #3b82f6;
}
</style>
